{
  "organizationLabel": "Organización:",
  "profileDropdownAccountInfoItem": "Información de la cuenta (interna)",
  "profileDropdownAccountSettingsHeader": "Configuración de la cuenta",
  "profileDropdownProductSettingsHeader": "Configuración de producto",
  "profileDropdownUserSettingsItem": "Preferencias",
  "profileLegalNoticesMenuItem": "Avisos legales",
  "signOut": "Cerrar sesión",
  "themeInfoTooltip": "No todas las aplicaciones admiten el tema oscuro.",
  "userProfileName": "{firstName} {lastName}",
  "userThemeSwitchLabel": "Tema oscuro"
}
